import { END_POINT } from "constants/apiConstant";
import { apiGet } from "../utils/apiUtils";

export const getDashboardDataApi = async () => {
  const response = await apiGet(END_POINT.GET_DASHBOARD_DATE_API);
  console.log("Dashboard-data-response---", response);
  return response;
};
